<div style="display: flex; flex-direction: column; height: 100%; width: 100%">
    <container-element [ngSwitch]="true" style="height: 100%;">
        <div *ngSwitchCase="uploadBatchStatus === ValidationStatus.NotRun"
            style="display: flex; justify-content: center; padding-top: 75px;flex-direction: column; align-items: center;">
            <div class="fal fa-exclamation-circle" style="font-size: 75px; color: #303F9F;"></div>
            <div style="font-size: 18px; padding-top: 12px;"><b>Upload batch validation has not been run.</b></div>
        </div>
        <div *ngSwitchCase="uploadBatchStatus === ValidationStatus.Validating"
            style="display: flex; justify-content: center; padding-top: 75px;flex-direction: column; align-items: center;">
            <span class="fal fa-traffic-cone" style="font-size: 75px;"></span>
            <div style="font-size: 18px; padding-top: 12px;"><b>Validating</b></div>
            <mat-progress-bar mode="indeterminate" color="accent"
                style="width:25%;padding-top: 12px;"></mat-progress-bar>
        </div>
        <div *ngSwitchCase="uploadBatchStatus === ValidationStatus.Passed || uploadBatchStatus === ValidationStatus.Failed || uploadBatchStatus === ValidationStatus.Warnings || uploadBatchStatus === ValidationStatus.Info"
            style="display: flex; flex-direction: column; z-index: 1; width: 100%; height:100%;">

            <div style="font-size: 20px; padding: 26px 0 0 35px;">
                <span class="fal fa-check-circle"></span>
                <span style="padding-left: 10px;">Validation</span>
            </div>
            <div style="display: flex; flex-direction: row; padding: 0px 24px;
        margin: 16px 16px;
        justify-content: space-between;
    align-items: stretch;">
                <button mat-button color="primary" style="width: 240px;" [routerLink]="['/', 'review', 'browse']"
                    [queryParams]="{UploadBatchId: uploadBatchId}">
                    <span style="font-size:20px;">{{uploadBatchTitle}}</span>
                </button>
                <div style="display: flex; gap: 12px;">
                    <span style="display: flex;
                align-items: flex-end;">Report last ran on {{dateTimeRun | date: 'medium'}}</span>
                    <div *inRole="[roles.Developer, roles.Operations]" style="display: flex; gap: 12px;">
                      <button mat-raised-button color="primary" id="queue-upload-batch-validation-{{uploadBatchId}}"
                              [disabled]="isProcessing" (click)="scheduleJobBatchValidation()">
                        <span class="fal fa-paper-plane"></span>
                        Rerun Validation
                      </button>
                      <button mat-raised-button color="primary" id="queue-delta-batch-repair-{{uploadBatchId}}" (click)="queueRepairJob()">
                        <i class="fa-duotone fa-screwdriver-wrench"></i>
                        Repair Missing Source Files
                      </button>
                    </div>
					@if(isProductionType) {
						<button [routerLink]="['/', 'case', 'dat-metadata-mapping', uploadBatchId]" mat-raised-button color="primary" id="dat-map-{{uploadBatchId}}" aria-label="Open DAT Mapping">
							<i class="fa-duotone fa-table-list" aria-hidden="true"></i>
							Dat Map
						</button>
					}
                </div>
            </div>
            <div class="mat-elevation-z2" style="overflow: hidden; flex: auto; display: flex;">
                <div *ngIf="metaTableDataSource" style="width: 50%; padding: 20px; overflow: auto;">
                    <lex-native-upload-batch-validation-meta [tableDataSource]="metaTableDataSource"
                        [uploadBatchTitle]="uploadBatchTitle" [uploadedTimestamp]="uploadedTimestamp">
                    </lex-native-upload-batch-validation-meta>
                </div>
                <div *ngIf="!metaTableDataSource"
                    style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                    <mat-spinner diameter="30"></mat-spinner>
                </div>
                <div *ngIf="ValidationStatus.Validating !== uploadBatchStatus"
                    style="width: 50%; padding: 20px; overflow: auto;display: flex;flex-direction: column;">
                    <div *ngIf="ValidationStatus.Passed === uploadBatchStatus"><mat-card-title>Pass! <span
                                class="fal fa-clipboard-check"></span></mat-card-title></div>
                    <div *ngIf="showErrors" style="margin-bottom: 20px;">
                        <mat-card-title>Errors</mat-card-title>
                        <ngx-charts-number-card class="error-card" bandColor="#D32F2F" cardColor="#FFEBEE"
                            [results]="errorData" (select)="select($event)">
                        </ngx-charts-number-card>
                    </div>
                    <div *ngIf="showWarnings" style="margin-bottom: 20px; width: 50%;">
                        <mat-card-title>Warnings</mat-card-title>
                        <ngx-charts-number-card class="warning-card" bandColor="#FFA000" cardColor="#FFF8E1"
                            [results]="warningData" (select)="select($event)">
                        </ngx-charts-number-card>
                    </div>
                    <div *ngIf="showInfo" style="margin-bottom: 20px;">
                        <mat-card-title>Info</mat-card-title>
                        <ngx-charts-number-card class="info-card" bandColor="#303F9F" cardColor="#E3F2FD"
                            [results]="infoData" (select)="select($event)">
                        </ngx-charts-number-card>
                    </div>
                </div>

            </div>
        </div>

        <div *ngSwitchCase="uploadBatchStatus === ValidationStatus.Error"
            style="display: flex; justify-content: center; padding-top: 75px;flex-direction: column; align-items: center;">
            <div class="fal fa-times-circle" style="font-size: 75px; color:#D32F2F;"></div>
            <div style="font-size: 18px; padding-top: 12px;">
                <b>The upload batch validation failed during processing. Please contact Professional Services.</b>
            </div>
        </div>
        <div *ngSwitchCase="uploadBatchStatus === ValidationStatus.Unsupported"
            style="display: flex; justify-content: center; padding-top: 75px;flex-direction: column; align-items: center;">
            <div class="fal fa-file-excel" style="font-size: 75px;"></div>
            <div style="font-size: 18px; padding-top: 12px;"><b>This upload batch is not supported for validation.</b>
            </div>
        </div>
        <div *ngSwitchDefault style="display: flex; justify-content: center; padding-top: 75px"><mat-spinner
                diameter="75"></mat-spinner></div>
    </container-element>
</div>
